import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import Footer from "../Common/Footer";
import Header from "../Common/Header";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { BorderBottom } from "@mui/icons-material";

import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { useContext } from "react";
import { getRecords, PostRecords } from "../Services/ApiCall";
import {
  callApi,
  makeApiRequest,
  sendLandPandaNotification,
} from "../Services/ApiService";
import FeaturedPropertiesList from "../Common/FeaturedPropertiesList";
import ProjectComp from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import {
  BaseUrl,
  Authorization_Token,
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
  staticToken,
  CRMAi_Url,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import CustomSearch from "../Classes/CustomSearch";
import { tab } from "@testing-library/user-event/dist/tab";
import {
  getUserLocation,
  sendWhatsAppMessage,
  sanitizeMessage,
} from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { useLocation } from "react-router-dom";
import {
  formatIndianAmount,
  getAvgPricePerSqft,
  addtoWishlist,
} from "../Services/Helper";
import { getDisplayPrice } from "../Services/Helper";
import SelectDialog from "../Common/Dialog/Select";
import { toast } from "react-toastify";
import { apiUrl_dialerp } from "../Services/Urls";
import { generate4DigitId } from "../Services/Helper";
import LoginDialog from "../Common/LoginDialog";
import ConfirmDialog from "../Common/Dialog/ConfirmDialog";
import CallsDialog from "../Common/Dialog/CallsDialog";
import ShareDialog from "../Common/Dialog/Share";
import AddImagesDialog from "../Common/Dialog/AddImagesDialog";
import ReportDialog from "../Common/Dialog/Report";

const images = [
  "https://images.pexels.com/photos/164522/pexels-photo-164522.jpeg",
  "https://images.pexels.com/photos/7031607/pexels-photo-7031607.jpeg",
  "https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg",
  "https://images.pexels.com/photos/534151/pexels-photo-534151.jpeg",
  "https://images.pexels.com/photos/13490214/pexels-photo-13490214.jpeg",
];

function PropertyDetails() {
  const navigate = useNavigate();
  const {
    logindata,
    setlogindata,
    setuserData,
    wishlist,
    setWishlist,

    userData,
  } = useContext(ApiContext);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const listingID = params.get("id");
  const TabID = location?.state?.TabID ?? params.get("TabID");

  const [open, setOpen] = useState(false);
  const [listingDetails, setlistingDetails] = useState(null);
  const [callData, setCallData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showStatusPopup, setshowStatusPopup] = useState(false);
  const [showSharePopup, setshowSharePopup] = useState(false);
  const [AddImagePopup, setAddImagePopup] = useState(false);
  const [showreportPopup, setshowreportPopup] = useState(false);

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next), // 👈 FIX
  };

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [openLogin, setOpenLogin] = useState(false);
  const [openConfirm, setopenConfirm] = useState(false);
  const [openCalls, setOpenCalls] = useState(false);

  const mediaMap = Object.fromEntries(
    Object.entries({
      "Main Image": listingDetails?.Images,
      Kitchen: listingDetails?.KitchenImage,
      Bathroom: listingDetails?.BathroomImage,
      Balcony: listingDetails?.BalconyImage,
      "Living Room": listingDetails?.LivingroomImage,
      Locality: listingDetails?.LocalityImage,
      "Floor Plan": listingDetails?.FloorPlanImage,
      "Dining Area": listingDetails?.DiningAreaImage,
      Others: listingDetails?.Others,
      Elevation: listingDetails?.ElevationImage,
      Bedroom: listingDetails?.BedroomImage,
      Videos: listingDetails?.Videos,
    }).filter(([_, value]) => value && value.trim() !== ""),
  );
  const [selectedType, setSelectedType] = useState("Main Image");

  // const totalImages = images.length;

  const mainSettings = {
    asNavFor: nav2,
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    swipeToSlide: true,
    slidesToScroll: 1,
    beforeChange: (_, next) => setActiveIndex(next),
  };

  const thumbSettings = {
    asNavFor: nav1,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    swipeToSlide: true,
    infinite: true,
    arrows: false,
  };

  useEffect(() => {
    getListingDetails(listingID);
    window.scrollTo(0, 0);
  }, []);

  const getListingDetails = (id) => {
    getRecords(TabID, 1, `{ListingID: { $in: [${id}] }}`, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setlistingDetails(data?.response?.records[0] || null);

          let data_listing = data?.response?.records[0];

          const isEmpty = (val) => !val || val.trim() === "";

          const allEmpty =
            isEmpty(data_listing?.Images) &&
            isEmpty(data_listing?.KitchenImage) &&
            isEmpty(data_listing?.BathroomImage) &&
            isEmpty(data_listing?.LivingroomImage) &&
            isEmpty(data_listing?.LocalityImage) &&
            isEmpty(data_listing?.FloorPlanImage) &&
            isEmpty(data_listing?.DiningAreaImage) &&
            isEmpty(data_listing?.Others) &&
            isEmpty(data_listing?.ElevationImage) &&
            isEmpty(data_listing?.BedroomImage) &&
            isEmpty(data_listing?.Videos);

          if (allEmpty) {
            setAddImagePopup(true);
          }

          setLoading(false);

          if (data?.response?.records[0]?.SellerID != LoggedInUserID) {
            updateView_Leads(data?.response?.records[0], true);
          }

          if (data?.response?.records[0]?.SellerID == LoggedInUserID) {
            getRecords(
              425,
              1000,
              `{'ListingID': { \$in: [ ${data?.response?.records[0]?.ListingID} ] },'PropertyTypeID': { \$in: [ ${data?.response?.records[0]?.PropertyTypeID} ] },'VerticalID': { \$in: [ ${data?.response?.records[0]?.VerticalID} ] }}`,
              1,
              "",
              (res) => {
                if (res != null) {
                  if (res?.hasErrors === false) {
                    setCallData(res?.response?.records || []);
                  } else {
                    console.log("Error in fetching featured properties", res);
                  }
                }
              },
            );
          }
        } else {
          setLoading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setLoading(false);
      }
    });
  };

  const updateView_Leads = (data, isNew) => {
    const url = `${BaseUrl}/api/CommonAPIs/AddUpdateStats`;
    const body = {
      PropertyType: data?.PropertyType,
      PropertyTypeID: data?.PropertyTypeID,
      Vertical: data?.Vertical,
      VerticalID: data?.VerticalID,
      ListingID: data?.ListingID,
      Title: data?.Title,
      isNew: isNew,
    };
    callApi(
      url,
      body,
      Authorization_Token ? Authorization_Token : staticToken,
      (res) => {
        if (res.hasErrors === false) {
          if (res?.response?.records != null) {
            //   setdata(res?.response?.records || []);
            // setLoading(false);
          } else {
            //   setdata([]);
            //   setLoading(false);
          }
        } else {
          //  setLoading(false);
        }
      },
    );
  };

  const csvFields = [
    listingDetails?.Images,
    listingDetails?.KitchenImage,
    listingDetails?.BathroomImage,
    listingDetails?.BalconyImage,
    listingDetails?.LivingroomImage,
    listingDetails?.LocalityImage,

    listingDetails?.FloorPlanImage,
    listingDetails?.DiningAreaImage,
    listingDetails?.Others,
    listingDetails?.ElevationImage,
    listingDetails?.BedroomImage,
  ];

  const sliderImages =
    csvFields
      .filter((v) => typeof v === "string" && v.trim())
      .flatMap((v) => v.split(",").map((i) => i.trim()))
      .filter(Boolean).length > 0
      ? csvFields
          .filter((v) => typeof v === "string" && v.trim())
          .flatMap((v) => v.split(",").map((i) => i.trim()))
          .filter(Boolean)
      : images;

  const totalImages = sliderImages?.length;

  const highlights =
    typeof listingDetails?.KeyHighlights === "string" &&
    listingDetails.KeyHighlights.trim()
      ? listingDetails.KeyHighlights.split(",")
          .map((h) => h.trim())
          .filter(Boolean)
      : [];

  const changeStatus = (flag) => {
    const postData = [
      {
        ListingID: listingID,

        Status: flag === 0 ? "In Review" : flag === 1 ? "Approved" : "Declined",
        StatusID: flag === 0 ? 1 : flag === 1 ? 2 : 3,
      },
    ];

    PostRecords(TabID, 1, postData, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`Status Updated Successfully`);
        getListingDetails(listingID);
      } else {
        toast.error(`${data?.errors}`);
      }
    });
  };

  const handleUpdatenav = (flag) => {
    if (flag) {
      navigate(`/update-property?id=${listingID}&tabid=${TabID}&step=6`);
    } else {
      navigate(`/update-property?id=${listingID}&tabid=${TabID}`);
    }
  };

  const handlechat = () => {
    //debugger;

    if (userData != null && LoggedInUserID != null) {
      setLoading(true);
      getRecords(
        414,
        1,
        `{'ListingID':{'\$in':[${listingDetails?.ListingID}]},'UserID':{'\$in':[${LoggedInUserID}]},'OwnerID':{'\$eq':${listingDetails?.SellerID}}}`,
        1,
        "",
        (data) => {
          if (data != null) {
            if (data?.hasErrors === false) {
              if (
                data?.response?.records != null &&
                data?.response?.records.length > 0
              ) {
                setLoading(false);
                navigate(`/chats?chatID=${data?.response?.records[0]?.ChatID}`);
              } else {
                let chatList = [
                  {
                    ListingID: listingDetails?.ListingID,
                    UserID: LoggedInUserID,
                    UserName: userData?.User || "User",
                    OwnerID: listingDetails?.SellerID,
                    OwnerName: listingDetails?.SellerName || "Owner",
                    LastMsg:
                      "Hi i am interested in your property, Is it still available?",
                    SenderID: LoggedInUserID,
                    MsgTime: new Date().toISOString(),
                    PropertyTitle: listingDetails?.Title || "Luxury Apartment",
                    CoverImage: sliderImages[0] || "base64_or_encoded_string",
                    Price:
                      getDisplayPrice(listingDetails)?.split(" ")[1] || "0",
                    TabID: TabID,
                  },
                ];

                PostRecords(414, 1, chatList, (res) => {
                  if (res != null && res?.response?.hasErrors === false) {
                    let msgbody = [
                      {
                        ChatID: res?.response?.response?.clientID,
                        ListingID: listingDetails?.ListingID,
                        SenderID: LoggedInUserID,
                        SenderName: userData?.User || "User",
                        ReceiverID: listingDetails?.SellerID,
                        ReceiverName: listingDetails?.SellerName || "Owner",
                        Msg: "Hi i am interested in your property, Is it still available?",
                        Type: "text",
                        Url: "",
                      },
                    ];

                    PostRecords(415, 1, msgbody, (resp) => {
                      if (resp != null && resp?.response?.hasErrors === false) {
                        navigate(
                          "/chats?chatID=" + res?.response?.response?.clientID,
                        );
                      } else {
                        setLoading(false);
                      }
                    });
                  } else {
                    setLoading(false);
                  }
                });
              }
            } else {
              setLoading(false);
              console.log("Error in fetching chat list", data);
            }
          } else {
            setLoading(false);
          }
        },
      );

      updateView_Leads(listingDetails, false);
    } else {
      setOpenLogin(true);
    }
  };

  const ordinal = (n) => {
    const num = Number(n);
    if (!num) return "";
    const mod100 = num % 100;
    if (mod100 >= 11 && mod100 <= 13) return `${num}th`;
    switch (num % 10) {
      case 1:
        return `${num}st`;
      case 2:
        return `${num}nd`;
      case 3:
        return `${num}rd`;
      default:
        return `${num}th`;
    }
  };

  const handleCallback = () => {
    //  console.log("decrypted otp", decryptedCode);

    if (userData != null && LoggedInUserID != null) {
      setopenConfirm(true);
    } else {
      setOpenLogin(true);
    }
  };

  const handleWishlist = () => {
    if (userData != null && LoggedInUserID != null) {
      addtoWishlist(listingDetails, wishlist, setWishlist);
    } else {
      setOpenLogin(true);
    }
  };

  const isWishlisted = (data) => {
    return wishlist.some(
      (item) =>
        item.ListingID === data?.ListingID &&
        item.VerticalID === data?.VerticalID &&
        item.PropertyTypeID === data?.PropertyTypeID,
    );
  };

  const sideImages = sliderImages?.slice(1, 5);
  const sideCount = sideImages?.length;

  const parseImages = (str) => {
    if (!str) return [];
    return str
      .split(",")
      .map((img) => img.trim())
      .filter(Boolean);
  };

  const filteredImages = selectedType
    ? parseImages(mediaMap?.[selectedType] || "")
    : Object.values(mediaMap).flatMap((val) => parseImages(val));

  const imagesToRender =
    Object.keys(mediaMap || {}).length > 0 ? filteredImages : sliderImages;

  // console.log("mediaMap", mediaMap);

  return (
    <>
      <div className="page-wrapper">
        <Header />
        <div className="content-wrapper bg-seashell prpdetails">
          <section className="property-details-wrap ptb-30">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  {/* Breadcrumb Start */}
                  {/* <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="breadcrumb-title pt-10 pb-10">
                        <ul className="breadcrumb-menu list-style">
                          <li>
                            <Link to="#">Home </Link>
                          </li>
                          <li>
                            <Link to="#">Projects in Noida </Link>
                          </li>
                          <li>
                            <Link to="#">Noida Greater Noida Expressway </Link>
                          </li>
                          <li>Sector 1 Noida</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div> */}

                  {/* Breadcrumb End */}
                </div>
              </div>
              <div className="row gx-5">
                <div className="col-xl-8">
                  <div className="property-details">
                    <div className="card mb-30">
                      <Grid
                        container
                        spacing={1}
                        className="d-desk d-deskk grid gridblock"
                        style={{
                          height: sideCount === 0 ? "400px" : "420px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={() => setOpen(true)}
                          className="vallimages allimage"
                        >
                          View All Images
                        </Button>
                        {/* LEFT IMAGE */}
                        <Grid
                          size={sideCount === 0 ? 12 : 6}
                          className="gridsec"
                        >
                          <div style={{ position: "relative", height: "100%" }}>
                            <img
                              src={
                                listingDetails?.Images?.split(",")[0] ||
                                "/assets/img/property/property-31.jpg"
                              }
                              alt=""
                              style={{
                                width: "100%",
                                height: sideCount === 0 ? "auto" : "100%",
                                objectFit: "cover",
                              }}
                            />

                            <div className="chipps chp">
                              {listingDetails?.FeaturedID == 1 && (
                                <span className="bg-orange">Featured</span>
                              )}
                              <span className="bg-green">
                                <i className="ri-shield-check-line"></i>{" "}
                                {listingDetails?.Status}
                              </span>
                            </div>
                          </div>
                        </Grid>

                        {/* RIGHT IMAGES */}
                        {sideCount > 0 && (
                          <Grid size={6} className="gridsec">
                            <Grid
                              container
                              spacing={1}
                              style={{ height: "100%" }}
                            >
                              {sideImages.map((img, index) => {
                                // dynamic sizing
                                let gridSize = 6;
                                let height = "50%";

                                if (sideCount === 1) {
                                  // 1 image → full height, full width
                                  gridSize = 12;
                                  height = "100%";
                                } else if (sideCount === 2) {
                                  // 2 images → stacked, each 50%
                                  gridSize = 12;
                                  height = "50%";
                                } else if (sideCount === 3 && index === 2) {
                                  // 3rd image → full width bottom
                                  gridSize = 12;
                                  height = "50%";
                                }

                                return (
                                  <Grid
                                    size={gridSize}
                                    key={index}
                                    className="gridsec"
                                    style={{ height }}
                                  >
                                    <img
                                      src={img}
                                      alt=""
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </Grid>
                                );
                              })}
                              <div
                                style={{ textAlign: "right", marginTop: -50 }}
                              ></div>
                            </Grid>
                          </Grid>
                        )}
                      </Grid>

                      <Box position="relative" className="d-mobile">
                        <Box
                          sx={{
                            position: "absolute",
                            top: 12,
                            right: 12,
                            zIndex: 2,
                            background: "rgba(0,0,0,0.6)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "12px",
                            fontSize: 14,
                          }}
                        >
                          {activeIndex + 1} / {totalImages}
                        </Box>

                        <Slider {...sliderSettings}>
                          {sliderImages?.map((img, index) => (
                            <div key={index}>
                              <img
                                src={img.trim()}
                                alt={`slide-${index}`}
                                style={{
                                  width: "100%",
                                  height: "280px",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            </div>
                          ))}
                        </Slider>

                        <div style={{ textAlign: "right", marginTop: -50 }}>
                          <Button
                            variant="outlined"
                            onClick={() => setOpen(true)}
                            className="vallimages"
                          >
                            View All Images
                          </Button>
                        </div>
                      </Box>
                    </div>
                    <div className="card pd-20 mb-30">
                      <div class="property-title mb-0">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "center",
                          }}
                        >
                          <h2>{listingDetails?.Title}</h2>{" "}
                          <div className="chipps chp" style={{ top: 4 }}>
                            <span className="bg-green">
                              <i class="ri-shield-check-line"></i>{" "}
                              {listingDetails?.Status}
                            </span>
                          </div>
                          {/* <span className="prce">
                          {getDisplayPrice(listingDetails)}
                        </span> */}
                        </div>

                        <ul
                          class="property-metainfo list-style"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <li>
                            <i class="flaticon-location"></i>
                            {listingDetails?.Locality}
                          </li>
                          {/* <li>
                          {listingDetails?.BuiltUpArea}{" "}
                          {listingDetails?.UOMName}
                        </li> */}
                        </ul>

                        <ul
                          class="property-metainfo list-style pdt-20 pdb-20 lstyle"
                          style={{
                            borderTop: "1px solid #f2f2f2",
                            borderBottom: "1px solid #f2f2f2",
                          }}
                        >
                          <li>
                            <div>
                              <span
                                className="prce"
                                style={{ color: "#000 !important" }}
                              >
                                {getDisplayPrice(listingDetails)}
                              </span>
                              {/* <small>₹11,600 per sqft</small> */}
                            </div>
                          </li>

                          {[2, 3, 4, 9, 10, 11, 12, 13, 28, 29].includes(
                            listingDetails?.ChoosePropertyID,
                          ) &&
                            listingDetails?.VerticalID != 3 && (
                              <>
                                <li>
                                  <i class="flaticon-double-bed"></i>

                                  <div>
                                    <b>
                                      {listingDetails?.BHK?.split(" ")[0] || ""}
                                    </b>
                                    <small className="d-block">Bedrooms</small>
                                  </div>
                                </li>

                                <li>
                                  <i class="flaticon-bath-tub"></i>
                                  <div>
                                    <b>
                                      {listingDetails?.BHK?.split(" ")[0] || ""}
                                    </b>
                                    <small className="d-block">Bathrooms</small>
                                  </div>
                                </li>
                              </>
                            )}

                          {listingDetails?.VerticalID === 3 && (
                            <>
                              <li>
                                <i class="flaticon-double-bed"></i>

                                <div>
                                  <b>{listingDetails?.TotalBeds || ""}</b>
                                  <small className="d-block">Beds</small>
                                </div>
                              </li>

                              <li>
                                <i class="ri-history-line"></i>
                                <div>
                                  <b>{listingDetails?.NoticePeriod || ""}</b>
                                  <small className="d-block">
                                    Notice Period
                                  </small>
                                </div>
                              </li>

                              <li>
                                <i class="ri-lock-fill"></i>
                                <div>
                                  <b>{listingDetails?.LockInPeriod || ""}</b>
                                  <small className="d-block">
                                    Lock-in Period
                                  </small>
                                </div>
                              </li>
                            </>
                          )}

                          {listingDetails?.VerticalID !== 3 && (
                            <li className="">
                              <i class="flaticon-square"></i>
                              <div>
                                <b> {listingDetails?.BuiltUpArea} </b>
                                <small className="d-block">Carpet Area</small>
                              </div>
                            </li>
                          )}
                        </ul>

                        {/* <div
                        className="headss"
                        style={{
                          marginLeft: 0,
                          borderBottom: "1px solid #f2f2f2",
                          marginBottom: 20,
                          justifyContent: "flex-start",
                        }}
                      >
                        <ul
                          className="property-metainfo list-style"
                          style={{
                            whiteSpace: "nowrap",
                            marginTop: 20,
                            marginBottom: 20,
                          }}
                        >
                          {Array.isArray(listingDetails?.UnitFurnishingtitle) &&
                            listingDetails.UnitFurnishingtitle.length > 0 &&
                            listingDetails.UnitFurnishingtitle.map(
                              (title, index) => (
                                <li key={index}>
                                  <img
                                    src={title?.UnitFurnishingIcon}
                                    alt="Furniture"
                                    style={{ height: 25, width: 25 }}
                                    // className="furnishing-icon"
                                  />
                                  {listingDetails?.Quantity
                                    ? `${listingDetails.Quantity} `
                                    : ""}
                                  {title?.UnitFurnishingtitle}
                                </li>
                              ),
                            )}
                        </ul>

                        <div className="chipps" style={{ marginLeft: 20 }}>
                          <span className="property-condo">
                            {listingDetails?.ChooseProperty}
                          </span>
                          <span className="property-status">
                            {listingDetails?.FurnishType}
                          </span>
                        </div>
                      </div> */}

                        <div className="filterownerchip filterownerchip2">
                          <div
                            className="agent d-flex"
                            style={{ alignItems: "center" }}
                          >
                            {/* <div
                            className="chipsn chip"
                            style={{ padding: "7px 17px" }}
                          >
                            {" "}
                            <i className="ri-shield-check-line"></i>Verified
                            Agent
                          </div> */}
                            <div className="chipps chp" style={{ margin: 0 }}>
                              <span className="bg-grey">
                                {listingDetails?.ChooseProperty}
                              </span>

                              {listingDetails?.FurnishType && (
                                <span className="bg-grey">
                                  {listingDetails?.FurnishType}
                                </span>
                              )}

                              {listingDetails?.ConstructionStatus && (
                                <span className="bg-grey">
                                  {listingDetails?.ConstructionStatus}
                                </span>
                              )}
                            </div>
                          </div>

                          {listingDetails?.SellerID == LoggedInUserID && (
                            <div
                              onClick={() => setOpenCalls(true)}
                              className="call"
                            >
                              {" "}
                              <div className="icoo">
                                <i class="ri-phone-fill"></i>
                              </div>{" "}
                              {callData?.length || 0} Call
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30 amenities">
                      <h5>
                        Property Details for{" "}
                        {`${listingDetails?.BHK || listingDetails?.ChooseProperty} in ${listingDetails?.Locality} `}
                      </h5>
                      <div class="property-desc mb-0">
                        <ul className="htlist">
                          <li className="d-flexx">
                            <span>Price</span>
                            <span>{getDisplayPrice(listingDetails)}</span>
                          </li>

                          <li className="d-flexx">
                            <span>Property Type</span>
                            <span>{listingDetails?.ChooseProperty}</span>
                          </li>

                          {listingDetails?.BuiltUpArea && (
                            <li className="d-flexx">
                              <span>Carpet Area</span>
                              <span>
                                {listingDetails?.BuiltUpArea}{" "}
                                {listingDetails?.UOMName}
                              </span>
                            </li>
                          )}

                          {listingDetails?.FurnishType && (
                            <li className="d-flexx">
                              <span>Furnishing</span>
                              <span>{listingDetails?.FurnishType}</span>
                            </li>
                          )}

                          {/* <li className="d-flexx">
                          <span>1 Covered</span>
                          <span>Parking</span>
                        </li>

                        <li className="d-flexx">
                          <span>Freehold</span>
                          <span>Ownership</span>
                        </li> */}

                          {listingDetails?.FloorNo && (
                            <li className="d-flexx">
                              <span>Floor</span>
                              <span>
                                {ordinal(listingDetails?.FloorNo)} floor of{" "}
                                {listingDetails?.TotalFloor}
                              </span>
                            </li>
                          )}

                          {listingDetails?.TotalBeds && (
                            <li className="d-flexx">
                              <span>Beds</span>
                              <span>{listingDetails?.TotalBeds}</span>
                            </li>
                          )}

                          {listingDetails?.NoticePeriod && (
                            <li className="d-flexx">
                              <span>Notice Period</span>
                              <span>{listingDetails?.NoticePeriod} days</span>
                            </li>
                          )}

                          {listingDetails?.LockInPeriod && (
                            <li className="d-flexx">
                              <span>Lock In Period</span>
                              <span>{listingDetails?.LockInPeriod} days</span>
                            </li>
                          )}

                          {listingDetails?.Facing && (
                            <li className="d-flexx">
                              <span>Facing</span>
                              <span>{listingDetails?.Facing}</span>
                            </li>
                          )}

                          {listingDetails?.R1_SecurityDeposit && (
                            <li className="d-flexx">
                              <span>Security Deposit</span>
                              <span>
                                ₹ {listingDetails?.R1_SecurityDeposit}
                              </span>
                            </li>
                          )}

                          <li className="d-flexx">
                            <span>Property ID</span>
                            <span>{listingDetails?.ListingID}</span>
                          </li>

                          {listingDetails?.PropertyAge && (
                            <li className="d-flexx">
                              <span>Property Age</span>
                              <span>{listingDetails?.PropertyAge}</span>
                            </li>
                          )}

                          {listingDetails?.ConstructionStatus && (
                            <li className="d-flexx">
                              <span>Construction Status</span>
                              <span>{listingDetails?.ConstructionStatus}</span>
                            </li>
                          )}

                          {listingDetails?.LocationHub && (
                            <li className="d-flexx">
                              <span>Location Hub</span>
                              <span>{listingDetails?.LocationHub}</span>
                            </li>
                          )}

                          {listingDetails?.Ownership && (
                            <li className="d-flexx">
                              <span>Ownership</span>
                              <span>{listingDetails?.Ownership}</span>
                            </li>
                          )}

                          {listingDetails?.Isitpreleasedprerented && (
                            <li className="d-flexx">
                              <span>Is it Preleased/Pre-Rented</span>
                              <span>
                                {listingDetails?.Isitpreleasedprerented}
                              </span>
                            </li>
                          )}

                          {listingDetails?.ExpectedROI && (
                            <li className="d-flexx">
                              <span>Expected ROI</span>
                              <span>{listingDetails?.ExpectedROI}%</span>
                            </li>
                          )}

                          <li className="d-flexx">
                            <span>Property Status</span>
                            <span>{listingDetails?.Status}</span>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>
                        Description for{" "}
                        {`${listingDetails?.BHK || listingDetails?.ChooseProperty} in ${listingDetails?.Locality}`}
                      </h5>
                      <div class="property-desc">
                        <p className="mb-20">{listingDetails?.Description}</p>

                        <h6>Key Highlights</h6>

                        <ul className="highlist">
                          {highlights?.length > 0 &&
                            highlights?.map((data, i) => {
                              return <li key={i}>{data}</li>;
                            })}
                        </ul>
                      </div>
                    </div>

                    {listingDetails?.PropertyAmenities && (
                      <div className="card pd-20 mb-30 amenities amtes">
                        <h5>
                          Amenities for{" "}
                          {`${listingDetails?.BHK || listingDetails?.ChooseProperty} in ${listingDetails?.Locality}`}
                        </h5>
                        <div class="property-desc">
                          <div className="row d-flex df">
                            {Array.isArray(listingDetails?.PropertyAmenities) &&
                              listingDetails.PropertyAmenities.length > 0 &&
                              listingDetails.PropertyAmenities.map(
                                (amenity, index) => (
                                  <div
                                    className="property-card style3"
                                    key={index}
                                  >
                                    <div className="property-info">
                                      <div className="icons">
                                        <img
                                          src={amenity?.PropertyAmenitiesIcon}
                                          alt="Furniture"
                                          style={{ height: 30, width: 30 }}
                                          // className="furnishing-icon"
                                        />
                                      </div>
                                      <p>{amenity?.PropertyAmenities}</p>
                                    </div>
                                  </div>
                                ),
                              )}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="card pd-20 mb-30">
                      <h5>Location</h5>
                      <div class="property-desc mb-0">
                        <ul
                          class="property-features list-style lst mb-0"
                          style={{ marginBottom: 0 }}
                        >
                          <li className="reraa">
                            <div className="d-flex">
                              <div className="grey ico">
                                <i class="ri-map-pin-line text-green-600 text-xl mt-1"></i>
                              </div>
                              <div>
                                <small className="d-block">
                                  {listingDetails?.City}
                                </small>
                                <small className="d-block">
                                  {listingDetails?.Locality}
                                </small>
                                {/* <a
                                href={`https://www.google.com/maps?q=${listingDetails?.Coordinates[0]},${listingDetails?.Coordinates[1]}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i class="ri-map-2-line"></i> View on Map
                              </a> */}
                              </div>
                            </div>
                          </li>
                        </ul>

                        <div class="embed-map-fixed">
                          <div class="embed-map-container">
                            <iframe
                              className="embed-map-frame"
                              frameBorder="0"
                              marginHeight="0"
                              marginWidth="0"
                              src={`https://maps.google.com/maps?q=${listingDetails?.Coordinates?.[0] ?? ""},${listingDetails?.Coordinates?.[1] ?? ""}&z=14&output=embed`}
                              style={{ width: "100%", height: 250 }}
                            ></iframe>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-4">
                  <div className="property-details">
                    <div className="card pd-20 mb-30">
                      <div class="property-title mb-0">
                        <h5>Contact Seller</h5>

                        <div className="d-flex">
                          <div className="dev">
                            <div className="developer">
                              <img src="assets/img/lplogo.jpg" alt="Image" />

                              <i class="ri-shield-check-fill text-white icnss"></i>
                            </div>
                          </div>
                          <div>
                            <span>
                              <b>{listingDetails?.SellerName}</b>
                            </span>
                            <div className="agent d-flex">
                              <div className="agent">
                                {" "}
                                <i className="ri-shield-check-line"></i>Verified
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="header-btn d-block dev">
                          {/* <button type="button" className="btn style1">
                          <i class="ri-phone-line"></i> Call Now
                        </button> */}

                          {/* {userData?.UserID != listingDetails?.SellerID && (
                            <button
                              onClick={() => handlechat()}
                              type="button"
                              className="btn style3 loginbtn"
                            >
                              <i class="ri-message-2-line"></i> Chat
                            </button>
                          )}

                          {userData?.UserID != listingDetails?.SellerID && (
                            <button
                              onClick={() => {
                                handleCallback();
                              }}
                              type="button"
                              className="btn style1"
                            >
                              {" "}
                              Get Callback{" "}
                            </button>
                          )}

                          {userData?.UserID != listingDetails?.SellerID && (
                            <button
                              onClick={() => handleWishlist()}
                              type="button"
                              className="btn style3 loginbtn"
                            >
                              <i
                                style={{ color: "red" }}
                                className={
                                  isWishlisted(listingDetails)
                                    ? "ri-heart-fill"
                                    : "ri-heart-line"
                                }
                              ></i>{" "}
                              Wishlist
                            </button>
                          )} */}
                        </div>
                      </div>
                    </div>
                    {/* <div className="card pd-20 mb-30">
                      <h5>EMI Calculator</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style ltype">
                          <li>
                            <span>Loan Amount</span> <span>₹60 Lakhs</span>
                          </li>

                          <li>
                            <span>Interest Rate</span>{" "}
                            <span>8.5% p.a.</span>{" "}
                          </li>
                          <li>
                            <span>Tenure</span> <span>20 Years</span>{" "}
                          </li>
                        </ul>
                        <ul
                          class="property-features list-style lst mb-0 pd-0 ltype tyle"
                          style={{ paddingBottom: 0 }}
                        >
                          <li
                            style={{
                              borderBottom: "1px solid #fff !important",
                              marginBottom: 0,
                              paddingBottom: 0,
                            }}
                          >
                            <span>Monthly EMI</span>{" "}
                            <span className="prce">₹51,745</span>{" "}
                          </li>
                        </ul>

                        <div className="header-btn d-block devv dline">
                          <button type="button" className="btn style3 loginbtn">
                            Calculate EMI
                          </button>
                        </div>
                      </div>
                    </div>  */}

                    <div className="card pd-20 mb-30">
                      <h5>Price Summary</h5>
                      <div class="property-desc">
                        <ul class="property-features list-style">
                          {listingDetails?.BHK && (
                            <li>
                              <span>Unit Type</span>{" "}
                              <span>{listingDetails?.BHK}</span>
                            </li>
                          )}

                          {listingDetails?.NoticePeriod && (
                            <li>
                              <span>Notice Period</span>{" "}
                              <span>{listingDetails?.NoticePeriod} days</span>
                            </li>
                          )}

                          {/* <li>
                          <span>Price Range</span>{" "}
                          <span>{getDisplayPrice(listingDetails)}</span>{" "}
                        </li> */}

                          {listingDetails?.BuiltUpArea && (
                            <li>
                              <span>Carpet Area</span>{" "}
                              <span>
                                {listingDetails?.BuiltUpArea}{" "}
                                {listingDetails?.UOMName}
                              </span>{" "}
                            </li>
                          )}

                          {listingDetails?.R1_SecurityDeposit && (
                            <li>
                              <span>Security Deposit</span>{" "}
                              <span>
                                {listingDetails?.R1_SecurityDeposit}{" "}
                              </span>{" "}
                            </li>
                          )}
                        </ul>
                        <ul
                          class="property-features list-style lst mb-0 pd-0"
                          style={{ paddingBottom: 0 }}
                        >
                          <li>
                            <span>Price/{listingDetails?.UOMName}</span>{" "}
                            <span className="prce">
                              {getDisplayPrice(listingDetails)}
                            </span>{" "}
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="card pd-20 mb-30">
                      <h5>Quick Actions</h5>
                      <div class="property-desc">
                        <div className="header-btn d-block dev savepr saveprr">
                          {/* <button type="button" className="btn style3 loginbtn">
                          <span class="text-lg">🖤</span> Save Property
                        </button> */}

                          <button
                            onClick={() => setshowSharePopup(true)}
                            type="button"
                            className="btn style3 loginbtn"
                          >
                            <i class="ri-share-line"></i> Share Property{" "}
                          </button>
                          {userData?.UserID == listingDetails?.SellerID && (
                            <button
                              onClick={() => handleUpdatenav(false)}
                              type="button"
                              className="btn style3 loginbtn"
                            >
                              <i class="ri-edit-line"></i> Edit Property{" "}
                            </button>
                          )}

                          {userData?.ProfileID === 4 && (
                            <button
                              onClick={() => setshowStatusPopup(true)}
                              type="button"
                              className="btn style3 loginbtn"
                            >
                              <i class="ri-status-line"></i> Change Status{" "}
                            </button>
                          )}

                          {userData?.UserID != listingDetails?.SellerID && (
                            <button
                              onClick={() => {
                                if (
                                  userData != null &&
                                  LoggedInUserID != null
                                ) {
                                  setshowreportPopup(true);
                                } else {
                                  setOpenLogin(true);
                                }
                              }}
                              type="button"
                              className="btn style3 loginbtn reportbtn"
                            >
                              <i class="ri-flag-line"></i> Report this
                              Property{" "}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <SelectDialog
          open={showStatusPopup}
          onClose={() => setshowStatusPopup(false)}
          onSubmit={(data) => {
            changeStatus(data);
            setshowStatusPopup(false);
          }}
        />
        <ShareDialog
          open={showSharePopup}
          onClose={() => setshowSharePopup(false)}
          onSubmit={(type) => {
            const url = `https://landpanda.com/property-details?id=${listingDetails?.ListingID}&TabID=${TabID}`;

            switch (type) {
              case 0: // Facebook
                window.open(
                  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
                  "_blank",
                );
                break;

              case 1: // Instagram (no direct share support)
                alert(
                  "Instagram sharing not supported directly. Copy link instead.",
                );
                break;

              case 2: // X (Twitter)
                window.open(
                  `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
                  "_blank",
                );
                break;

              case 3: // WhatsApp
                window.open(
                  `https://wa.me/?text=${encodeURIComponent(url)}`,
                  "_blank",
                );
                break;

              case 4: // Copy URL
                navigator.clipboard.writeText(url);
                alert("Link copied!");
                break;

              default:
                break;
            }

            setshowSharePopup(false);
          }}
        />
        <AddImagesDialog
          open={AddImagePopup}
          onClose={() => {
            //  setAddImagePopup(false);
            toast.info("Please add atleast one image to proceed.");
          }}
          onAddPhotos={(e) => {
            e.preventDefault();
            setAddImagePopup(false);
            handleUpdatenav(true);
          }}
        />
        <ReportDialog
          open={showreportPopup}
          onClose={() => setshowreportPopup(false)}
          details={listingDetails}
          onSubmit={(type) => {
            setshowreportPopup(false);
          }}
        />
        <LoginDialog
          open={openLogin}
          onClose={() => setOpenLogin(false)}
          onSuccess={(data) => {
            if (data) {
              //  console.log("Login Success:", data);
              setLogindata(data);
              setlogindata(data);

              localStorage.setItem("loginData", JSON.stringify(data));
            }

            //  setUser(data);
          }}
          onUserDetails={(userDetails) => {
            if (userDetails) {
              // console.log("User Details:", userDetails);
              setUserdata(userDetails);
              setuserData(userDetails);
              localStorage.setItem("UserData", JSON.stringify(userDetails));
            }
          }}
        />
        {loading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255,255,255,0.7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <TailSpin color="#00BFFF" height={80} width={80} />
          </div>
        )}
        <ConfirmDialog
          open={openConfirm}
          onClose={() => setopenConfirm(false)}
          onSubmit={() => {
            // submit logic here
            setopenConfirm(false);
            // let url3 = `${apiUrl_dialerp}/api/DynamicSMS/SendSMS?AppVersion=1.85&appName=${"LandPanda"}&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
            // let body3 = {
            //   Message: `Dear Seller,You have a new enquiry for you property id: ${listingID} Customer:Enquiry ID: ${generate4DigitId()} \nTeam Landpanda`,
            //   SubscriberID: 10001,
            //   DltEntityID: "1201159187215982418",
            //   TemplateDltID: "1007053991992949231",
            //   SenderID: "DALERP",
            //   CountryCode: "91",
            //   userID: "2",
            //   Mobile: listingDetails?.SellerMobile,
            // };

            // makeApiRequest(
            //   url3,
            //   body3,
            //   "",
            //   (response3) => {
            //     //if() console.log("SMS API response", response3);
            //     // if (response3.hasErrors === false) {
            //     //   toast.success("Enquiry Sent Successfully");
            //     // } else {
            //     //   toast.error("Error in sending Enquiry");
            //     // }
            //   },
            //   (error3) => {
            //     // setLoading(false);
            //   },
            // );

            sendLandPandaNotification([
              {
                title: `New Enquiry`,
                coverImage: "",
                chatID: 0,
                listingID: listingID,
                tabID: TabID,
                userName: userData?.User,
                OwnerID: listingDetails?.SellerID,
                OwnerName: listingDetails?.SellerName,
                body: `Dear Seller,You have a new enquiry for you property id: ${listingID} \nCustomer: ${userData?.User} \nMobile : ${userData?.Mobile} \nEnquiry ID: ${generate4DigitId()} \nTeam Landpanda`,
                appID: 1,
                Price: listingDetails?.Price,
                userId: listingDetails?.SellerID,
                parentId: 10027,
              },
            ]);

            let enqBody = [
              {
                ListingID: listingDetails?.ListingID,
                PropertyTypeID: listingDetails?.PropertyTypeID,
                VerticalID: listingDetails?.VerticalID,
                SellerName: listingDetails?.SellerName,
                SellerID: listingDetails?.SellerID,
                SellerMobile: listingDetails?.SellerMobile,
                UserName: userData?.User,
                UserID: userData?.UserID,
                UserMobile: userData?.Mobile,
                Remarks: `Callback Enquiry For ${listingDetails?.Title} `,
              },
            ];

            PostRecords(425, 1, enqBody, (data) => {
              if (data.hasErrors === false) {
                toast.success("Enquiry Sent Successfully");
              } else {
                toast.error("Error in sending Enquiry");
              }
            });

            const message = sanitizeMessage(
              `Dear Seller, You have a new enquiry for your property id: ${listingDetails?.ListingID}
                Customer: ${userData?.User}
                Mobile: ${userData?.Mobile}
                Enquiry ID: ${generate4DigitId()}
                Team Landpanda`,
            );

            // sendWhatsAppMessage("918796011518", message);

            const whatsappUrl = `${CRMAi_Url}/api/Whatsapp/SendWhatsAppMsg`;
            const whatsappBody = {
              WANumber: "919971122333",
              PhoneNumberId: "866236006563334",
              Name: "",
              WaId: `91${listingDetails?.SellerMobile}`,
              CustomerMobile: `91${listingDetails?.SellerMobile}`,
              apikey: "WhatsappApiKey",
              Text: "Thank you for contacting us. We have shared your query with our team. One of our team members will contact you shortly.\n\nTeam\nDial ERP Technologies Ltd\nhttps://www.DialERP.com\n+91-9971122333",
              Status: "Sent",
              StatusID: "1",
              Direction: "Outbound",
              DirectionID: "2",
              MsgType: 1,
              TeamplateName: "welcome_msg",
              ProviderID: 5,
              ProjectID: "1126856509412508",
              TemplateMediaUrl: "",
              TemplateMediaType: "TEXT",
              TemplateFileName: "",
            };

            const whatsappToken = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4OTBlNTZhYS1jYzQxLTQ0NDYtYTM0OC03ZTVmNzQ2YWU0NzkiLCJhdXRoX3RpbWUiOiI2MzkxMzYzNzY4NzQ1OTYzNDQiLCJTdWJzY3JpYmVySUQiOiIxMDAyNCIsIkxlZGdlcklEIjoiMyIsIlN0YXR1cyI6IkFjdGl2ZSIsIlN0YXR1c0lEIjoiMSIsIlJvbGUiOiJBZG1pbiIsIlJvbGVJRCI6IjEiLCJSb2xlVHlwZSI6IlN5c3RlbSIsIlJvbGVUeXBlSUQiOiIxIiwiTGVkZ2VyIjoiU3VyYWogTmlrYW0iLCJFbWFpbCI6InN1cmFqbmlrYW00MDRAZ21haWwuY29tIiwiTW9iaWxlIjoiNzc3NjgwNjAwNiIsIlN1YnNJRCI6IjEwMDI0IiwiQ29tcGFueU5hbWUiOiJTYWxlcyBEaWFsRVJQIiwiSW5kdXN0cnkiOiJJVCIsIkluZHVzdHJ5SUQiOiIxIiwiUGluY29kZSI6IjExMDAwOCIsIkNpdHkiOiJDZW50cmFsIiwiU3RhdGUiOiJEZWxoaSIsIlN0YXRlQ29kZSI6IjA3IiwiQ291bnRyeSI6IkluZGlhIiwiVGltZXpvbmUiOiJJbmRpYSBTdGFuZGFyZCBUaW1lIiwiVGltZXpvbmVTeW1ib2wiOiIrIiwiVVRDT2Zmc2V0IjoiMDU6MzAiLCJUaW1lem9uZUlEIjoiMSIsIkN1cnJlbmN5IjoiSU5SIiwiQ3VycmVuY3lJRCI6IjEiLCJlbWFpbCI6InN1cmFqbmlrYW00MDRAZ21haWwuY29tIiwiU3ViZG9tYWluIjoic2FsZXMiLCJ0cyI6IjE3NzgwNDA4ODciLCJBcHBJRCI6IjAiLCJBcHBOYW1lIjoiRGlhbCBDUk0gQWkgV2ViIiwiZXhwIjoxNzgwNzE5Mjg3LCJpc3MiOiJ3aGl0ZWJpbGxzLmNvbSIsImF1ZCI6IndoaXRlYmlsbHMuY29tIn0.k5hrFSn5h0anKlmC8f4IA0BYsdr7x325jj4dcM0mhGw`;

            callApi(
              whatsappUrl,
              whatsappBody,
              whatsappToken,
              (response) => {
                // console.log("WhatsApp API response", response);
              },
              (error) => {
                // console.error("WhatsApp API error", error);
              },
            );
          }}
          title="Request Callback"
          message="Do you want to request a callback now?"
          confirmText="Yes, Request"
          cancelText="No, Cancel"
        />
        <CallsDialog
          open={openCalls}
          data={callData}
          onClose={() => setOpenCalls(false)}
          onSubmit={() => {}}
        />
        ;{/* Gallery Dialog */}
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          fullWidth
          maxWidth="md"
        >
          <IconButton
            onClick={() => setOpen(false)}
            style={{ position: "absolute", right: 8, top: -3, zIndex: 9999 }}
          >
            x
          </IconButton>

          <DialogContent style={{ padding: 0, overflowY: "clip" }}>
            {/* Chips */}

            {/* <div
              className="chipps chp chrp"
              style={{ margin: 0, position: "relative", marginBottom: 20 }}
            >
              <span className="bg-grey">Main Image</span>
              <span className="bg-grey">Project Image</span>
            </div> */}

            {Object?.keys(mediaMap)?.length > 0 && (
              <div
                className="chipps chp chrp"
                style={{ margin: 0, position: "relative", marginBottom: 20 }}
              >
                {Object?.keys(mediaMap)?.map((key) => (
                  <span
                    key={key}
                    // className="bg-grey"
                    style={{
                      marginRight: 8,
                      cursor: "pointer",
                      background: selectedType === key ? "#1976d2" : "#eee",
                      color: selectedType === key ? "#fff" : "#000",
                      padding: "6px 10px",
                      borderRadius: 6,
                    }}
                    onClick={() => setSelectedType(key)}
                  >
                    {key}
                  </span>
                ))}
              </div>
            )}

            <Box position="relative">
              {/* Counter */}
              <Box
                sx={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  zIndex: 2,
                  background: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: 14,
                }}
              >
                {activeIndex + 1} /{" "}
                {Object?.keys(mediaMap)?.length > 0
                  ? filteredImages?.length
                  : totalImages}
              </Box>

              {/* Main Slider */}
              <Slider {...mainSettings} ref={(s) => setNav1(s)}>
                {imagesToRender?.map((img, index) => (
                  <Box key={index}>
                    <img
                      src={img}
                      alt=""
                      style={{
                        width: "100%",
                        height: 300,
                        objectFit: "cover",
                      }}
                    />
                  </Box>
                ))}
              </Slider>

              {/* Thumbnails */}
              <Box mt={2}>
                <Slider {...thumbSettings} ref={(s) => setNav2(s)}>
                  {imagesToRender?.map((img, index) => (
                    <Box key={index} px={0.5}>
                      <img
                        src={img}
                        alt=""
                        style={{
                          width: "100%",
                          height: 80,
                          objectFit: "cover",
                          cursor: "pointer",
                          border:
                            activeIndex === index
                              ? "2px solid #1976d2"
                              : "2px solid transparent",
                        }}
                      />
                    </Box>
                  ))}
                </Slider>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
        <Footer />
        <div className="fixedbuttns">
          {userData?.UserID != listingDetails?.SellerID && (
            <>
              <button
                onClick={() => {
                  if (userData != null && LoggedInUserID != null) {
                    handleCallback();
                  } else {
                    setOpenLogin(true);
                  }
                }}
                type="button"
                className="btn style1 btnn1"
              >
                <i class="ri-phone-line"></i> Get Callback
              </button>
              <button
                onClick={() => {
                  if (userData != null && LoggedInUserID != null) {
                  } else {
                    setOpenLogin(true);
                  }
                }}
                type="button"
                className="btn style1 btnn2"
              >
                <i class="ri-chat-2-line"></i> {"Chat"}
              </button>
              <button
                onClick={() => handleWishlist()}
                type="button"
                className="btn btnn3"
              >
                <i
                  style={{ color: "red" }}
                  className={
                    isWishlisted(listingDetails)
                      ? "ri-heart-fill"
                      : "ri-heart-line"
                  }
                ></i>{" "}
                Save
              </button>
            </>
          )}
        </div>
        <div className="fixedbuttnsweb">
          <div className="d-flex">
            <div className="dev">
              <div className="fixedbaricon">
                <i class="ri-building-4-line text-lg text-emerald-600"></i>
              </div>
            </div>
            <div>
              <span style={{ color: "#000" }}>
                <b>{listingDetails?.Title}</b>
              </span>
              <div className="d-flex" style={{ color: "grey" }}>
                <small>Get in touch with the Owner</small>
              </div>
            </div>
          </div>
          <div>
            {userData?.UserID != listingDetails?.SellerID && (
              <>
                <button
                  onClick={() => {
                    if (userData != null && LoggedInUserID != null) {
                      handlechat();
                    } else {
                      setOpenLogin(true);
                    }
                  }}
                  type="button"
                  className="btn style1"
                >
                  <i class="ri-chat-2-line"></i> {"Chat"}
                </button>
                <button
                  onClick={() => {
                    if (userData != null && LoggedInUserID != null) {
                      handleCallback();
                    } else {
                      setOpenLogin(true);
                    }
                  }}
                  type="button"
                  className="btn style3"
                >
                  <i class="ri-file-text-line text-base"></i> Get Callback
                </button>
                <button
                  onClick={(e) => {
                    if (userData != null && LoggedInUserID != null) {
                      addtoWishlist(listingDetails, wishlist, setWishlist);
                    } else {
                      setOpenLogin(true);
                    }
                  }}
                  type="button"
                  className="btn btnn3 wishbtn"
                >
                  <i
                    style={{
                      color: `${isWishlisted(listingDetails) ? "red" : "lightgrey"}`,
                    }}
                    class={
                      isWishlisted(listingDetails)
                        ? "ri-heart-fill"
                        : "ri-heart-line"
                    }
                  ></i>{" "}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PropertyDetails;
